import { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext(null);

const translations = {
  es: {
    dashboard: 'Dashboard',
    agenda: 'Agenda',
    recruitment: 'Reclutamiento',
    volunteers: 'Voluntarios',
    studies: 'Estudios',
    statistics: 'Estadisticas',
    clients: 'Clientes',
    warehouse: 'Almacen',
    communications: 'Comunicaciones',
    settings: 'Configuracion',
    audit: 'Auditoria',
    support: 'Soporte',
    login: 'Iniciar Sesion',
    logout: 'Cerrar Sesion',
    email: 'Correo electronico',
    password: 'Contrasena',
    welcome: 'Bienvenido',
    sign_in_subtitle: 'Accede a tu cuenta para continuar',
    total_volunteers: 'Voluntarios',
    active_studies: 'Estudios activos',
    total_clients: 'Clientes',
    total_samples: 'Muestras',
    appointments_today: 'Citas hoy',
    quick_access: 'Acceso rapido',
    agenda_desc: 'Crear una nueva cita en la agenda',
    volunteers_desc: 'Dar de alta un nuevo voluntario',
    studies_desc: 'Configuracion y trabajo en estudios clinicos',
    clients_desc: 'Informacion y gestion de clientes',
    warehouse_desc: 'Trazabilidad de muestras recibidas',
    settings_desc: 'Configuracion del sistema y usuarios',
    audit_desc: 'Audit Trail y registro ALCOA',
    module_coming_soon: 'Modulo en desarrollo',
    module_description: 'Este modulo se desarrollara proximamente',
    planned_features: 'Funcionalidades planificadas',
    audit_trail: 'Registro de Auditoria',
    user: 'Usuario',
    action: 'Accion',
    module_label: 'Modulo',
    date: 'Fecha',
    details: 'Detalles',
    ip_address: 'Direccion IP',
    no_records: 'No hay registros',
    loading: 'Cargando...',
    role: 'Rol',
    profile: 'Mi Perfil',
    all_modules: 'Todos',
    search: 'Buscar',
    name: 'Nombre',
    create_volunteer: 'Crear Voluntario',
    new_volunteer: 'Nuevo Voluntario',
    new_appointment: 'Nueva Cita',
    edit_volunteer: 'Editar Voluntario',
    save: 'Guardar',
    cancel: 'Cancelar',
    documentation: 'Documentacion',
    status: 'Estado',
  },
  en: {
    dashboard: 'Dashboard',
    agenda: 'Agenda',
    recruitment: 'Recruitment',
    volunteers: 'Volunteers',
    studies: 'Studies',
    statistics: 'Statistics',
    clients: 'Clients',
    warehouse: 'Warehouse',
    communications: 'Communications',
    settings: 'Settings',
    audit: 'Audit',
    support: 'Support',
    login: 'Sign In',
    logout: 'Sign Out',
    email: 'Email',
    password: 'Password',
    welcome: 'Welcome',
    sign_in_subtitle: 'Sign in to your account to continue',
    total_volunteers: 'Volunteers',
    active_studies: 'Active Studies',
    total_clients: 'Clients',
    total_samples: 'Samples',
    appointments_today: "Today's Appointments",
    quick_access: 'Quick Access',
    agenda_desc: 'Create a new appointment',
    volunteers_desc: 'Register a new volunteer',
    studies_desc: 'Clinical study configuration and management',
    clients_desc: 'Client information and management',
    warehouse_desc: 'Sample traceability management',
    settings_desc: 'System and user configuration',
    audit_desc: 'Audit Trail and ALCOA compliance',
    module_coming_soon: 'Module under development',
    module_description: 'This module will be developed soon',
    planned_features: 'Planned features',
    audit_trail: 'Audit Trail',
    user: 'User',
    action: 'Action',
    module_label: 'Module',
    date: 'Date',
    details: 'Details',
    ip_address: 'IP Address',
    no_records: 'No records found',
    loading: 'Loading...',
    role: 'Role',
    profile: 'My Profile',
    all_modules: 'All',
    search: 'Search',
    name: 'Name',
    create_volunteer: 'Create Volunteer',
    new_volunteer: 'New Volunteer',
    new_appointment: 'New Appointment',
    edit_volunteer: 'Edit Volunteer',
    save: 'Save',
    cancel: 'Cancel',
    documentation: 'Documentation',
    status: 'Status',
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('es');

  const t = useCallback((key) => translations[lang]?.[key] || key, [lang]);
  const toggleLanguage = useCallback(() => setLang(prev => prev === 'es' ? 'en' : 'es'), []);

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLanguage, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
